/*

  const handleRetry = () => {
    console.log('Retry action triggered');
  };
  
    showNotification({
      notification: 'Word list was not updated. Please try again',
      type: 'warning',
      extra: { someInfo: 'Additional error info' },
      isException: true,
      actions: [
        { label: 'Retry', onClick: handleRetry },
      ],
    });
  */
import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Slide, Button, SnackbarContent, Stack, IconButton } from '@mui/material';

import {
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    Warning as WarningIcon,
    Info as InfoIcon,
    Close as CloseIcon,
    Check as CheckIcon,
    Done as DoneIcon,
    ThumbUp as ThumbUpIcon,
    ThumbDown as ThumbDownIcon,
    Help as HelpIcon,
} from '@mui/icons-material';
  
import { logError } from '../utils/errorLogger'; // Import your error logger

function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }
const NotificationContext = createContext();

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [notification, setNotification] = useState('');
    const [type, setType] = useState('info'); // Default message type
    const [actions, setActions] = useState([]);

  const showNotification = ({
    notification = '',
    type = 'info',  // Can be 'error', 'warning', 'success', or 'info'
    extra = {},
    error = {},
    isException = false,
    actions = [], // Buttons on snackbar 
  }) => {

    // Log the message if necessary
    if (type === 'error') {
      if (isException) {
        logError(error, extra, isException);  // Only log errors
      } else {
        logError(notification, extra, isException);  // Only log  messages
      } 
    }

    // Set message, type, and actions
    setNotification(notification);
    setType(type);
    setActions(actions);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Define styles based on the message type
  const getSnackbarStyles = (type) => {
    switch (type) {
      case 'success':
        return {
            borderRadius: '50px',
            backgroundColor: 'var(--snackbar-success-background-color)',  // Blue for info
            color: 'var(--snackbar-success-text-color)',     
        };
      case 'error':
        return {
            borderRadius: '50px',
            backgroundColor: 'var(--snackbar-error-background-color)',
            color: 'var(--snackbar-error-text-color)',     
        };
      case 'warning':
        return {
            borderRadius: '50px',
            backgroundColor: 'var(--snackbar-warning-background-color)',
            color: 'var(--snackbar-warning-text-color)',     
        };
      case 'info':
      default:
        return {
            borderRadius: '50px',
            backgroundColor: 'var(--snackbar-info-background-color)',  // Blue for info
            color: 'var(--snackbar-info-text-color)',     
        };
    }
  };

  // Define the icon based on the message type
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon fontSize="small" style={{ marginRight: 8 }} />;
      case 'error':
        return <ErrorIcon fontSize="small" style={{ marginRight: 8 }} />;
      case 'warning':
        return <WarningIcon fontSize="small" style={{ marginRight: 8 }} />;
      case 'info':
      default:
        return <InfoIcon fontSize="small" style={{ marginRight: 8 }} />;
    }
  };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
          {children} {/*the rest of the whole app*/}
          <Stack spacing={2} sx={{ maxWidth: 600 }}>
            <Snackbar
                open={open}
                //autoHideDuration={6000}
                onClose={handleClose}
                TransitionComponent={SlideTransition}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                    <SnackbarContent
                      sx={{
                        ...getSnackbarStyles(type),
                        display: 'flex', // Keep flex layout
                        alignItems: 'center', // Align items properly
                        justifyContent: 'space-between', // Ensure elements are in one row
                        flexWrap: 'nowrap', // Prevent wrapping, but allow shrinking
                        maxWidth: '100%', // Ensure it doesn't exceed the screen width
                        width: 'auto', // Allow it to adjust dynamically
                      }}
                      message={
                        <span style={{ paddingLeft: '10px', display: 'flex', alignItems: 'center' }}>
                          {getIcon(type)}  {/* Icon based on message type */}
                          <span style={{ marginLeft: 8, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {notification}
                          </span>
                        </span>
                      }
                      action={
                        <>
                        {actions.map((action, index) => (
                            <Button
                            key={index}
                            size="small"
                            variant="notificationAction"  // Use the custom variant
                            onClick={action.onClick}
                            sx={{
                              color: 'inherit',  // Inherit text color from SnackbarContent
                            }}
                            >
                            {action.label} {/*Action button*/}
                            </Button>
                        ))}

                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleClose}
                            sx={{
                              borderRadius: '50%',  // Make the button circular
                              flex: 1,
                              marginLeft: '8px',  // Add space between close button and actions
                              padding: '8px',  // Make the button larger for better accessibility
                              '&:hover': {
                                  backgroundColor: 'rgba(0, 0, 0, 0.1)',  // Customize hover background
                                  borderRadius: '50%',  // Ensure it stays rounded on hover
                              },
                          }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        </>
                    }
                    />
                </Snackbar>
            </Stack>

        </NotificationContext.Provider>
    );
};
